var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoSignRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FD3845"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8105 24.6465H32.9434V44H27.8105V24.6465ZM30.377 22.5371C29.6152 22.5371 28.9648 22.2793 28.4258 21.7637C27.8867 21.248 27.6172 20.6094 27.6172 19.8477C27.6172 19.0859 27.8867 18.4473 28.4258 17.9316C28.9648 17.4277 29.6152 17.1758 30.377 17.1758C31.1504 17.1758 31.8066 17.4277 32.3457 17.9316C32.8848 18.4473 33.1543 19.0859 33.1543 19.8477C33.1543 20.6094 32.8848 21.248 32.3457 21.7637C31.8066 22.2793 31.1504 22.5371 30.377 22.5371Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSignRed);
export default __webpack_public_path__ + "static/media/info-sign-red.9cdc654ce45ee08c3477c489b897f46e.svg";
export { ForwardRef as ReactComponent };